// extracted by mini-css-extract-plugin
export var checkbox = "checkbox-module--checkbox--b4806";
export var fadeInAnimation = "checkbox-module--fadeInAnimation--2cb09";
export var hint = "checkbox-module--hint--f3e67";
export var item = "checkbox-module--item--4461d";
export var itemTitle = "checkbox-module--itemTitle--5b8be";
export var label = "checkbox-module--label--f9849";
export var list = "checkbox-module--list--0c239";
export var tag = "checkbox-module--tag--0861d";
export var title = "checkbox-module--title--a5788";